import { formatDistance as o } from "./de/_lib/formatDistance.js";
import { formatLong as t } from "./de/_lib/formatLong.js";
import { formatRelative as a } from "./de/_lib/formatRelative.js";
import { localize as r } from "./de/_lib/localize.js";
import { match as e } from "./de/_lib/match.js";
const s = {
  code: "de",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
export {
  s as de,
  s as default
};
